
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.245 12.764H5.771l-.158-.369s.053.895-.105.895-.105-5.106-.105-5.106l-.105-.368-5.264-.632s-.158-1.526.21-1.526 5.159-.21 5.159-.21H6.77s.053-2.633.106-2.843c.052-.264.526-.264.526-.264v-.21s-1.158.052-1.158-.053 1.158-.105 1.158-.105.053-.263.105-.263.106.316.106.316 1.158 0 1.158.105-1.158.052-1.158.052v.211s.473-.053.526.263c.053.21.105 2.843.105 2.843h1.369s4.843.158 5.159.21c.315.053.21 1.527.21 1.527l-5.264.631-.105.316s.053 5.054-.105 5.054-.106-.895-.106-.895l-.158.42zm.053-1.316l-.053-3.316-.105-.264h-.895l-.105-.105c0 .105.053.421-.158.79-.105.21-.263.316-.368.42v.211s1.158-.052 1.158.053-1.158.105-1.158.105-.053.264-.106.264-.105-.316-.105-.316-1.158 0-1.158-.106 1.158-.052 1.158-.052v-.21c-.105-.053-.263-.211-.368-.422-.158-.316-.158-.632-.158-.79l-.106.106h-.894l-.106.263-.052 3.316h3.58v.053z"}})])
          )
        }
      }
    